import React, { memo, forwardRef } from "react";
const SvgIntegralvalues = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M17.41 6.075c.37.899.59 2.045.59 3.313a1 1 0 11-2 0c0-1.05-.185-1.931-.44-2.553a2.648 2.648 0 00-.383-.678 1.027 1.027 0 00-.105-.11 1.364 1.364 0 00-.161.24c-.278.502-.567 1.492-.698 3.178-.053.682-.105 1.404-.16 2.152-.22 3.023-.47 6.461-.902 9.333-.269 1.785-.618 3.428-1.104 4.647-.243.607-.545 1.175-.94 1.607-.408.445-.968.796-1.675.796-.551 0-1.09-.12-1.575-.409-.486-.289-.857-.71-1.13-1.218-.525-.977-.727-2.34-.727-4.008a1 1 0 112 0c0 1.577.204 2.53.489 3.06.132.246.268.375.39.448.123.073.294.127.553.127.007 0 .016 0 .039-.012a.617.617 0 00.16-.135c.164-.179.358-.497.558-.998.399-.997.72-2.454.984-4.203.42-2.787.662-6.12.882-9.14.056-.758.11-1.497.164-2.202.14-1.79.459-3.117.941-3.99.244-.442.567-.836 1-1.08a1.792 1.792 0 011.464-.147c.869.286 1.443 1.147 1.786 1.982z"
        clipRule="evenodd"
      />
      <rect width={8} height={6} x={19} y={4} fill="#D9D9D9" rx={1} />
      <rect width={8} height={6} x={14} y={22} fill="#D9D9D9" rx={1} />
    </svg>
  );
});
SvgIntegralvalues.displayName = "SvgIntegralvalues";
const MemoForwardRef = memo(SvgIntegralvalues);
export default MemoForwardRef;
